export enum InteractionType {
  CALL = "call",
  CREATED = "created",
  EMAIL = "email",
  TEXT = "text",
}

export enum HubInteractionTypeFilter {
  CALL = InteractionType.CALL,
  EMAIL = InteractionType.EMAIL,
  TEXT = InteractionType.TEXT,
}

export enum ChannelType {
  WEB_SMS = "web-sms",
  GLSA_SMS = "glsa-sms",
  TWILIO_SMS = "twilio-sms",
}

export enum HubInteractionChannelTypeFilter {
  WEB_SMS = ChannelType.WEB_SMS,
  GLSA_SMS = ChannelType.GLSA_SMS,
}

export enum InteractionTypeDisplay {
  CALL = InteractionType.CALL,
  CREATED = InteractionType.CREATED,
  TEXT = InteractionType.TEXT,
  TRANSFER = "transfer",
  DIGITAL_LEADS = "digital-leads",
  WEB_SMS = "web-sms",
  EMAIL = "email",
}

export const toInteractionTypeDisplay: Record<InteractionType, InteractionTypeDisplay> = {
  [InteractionType.CALL]: InteractionTypeDisplay.CALL,
  [InteractionType.CREATED]: InteractionTypeDisplay.CREATED,
  [InteractionType.EMAIL]: InteractionTypeDisplay.EMAIL,
  [InteractionType.TEXT]: InteractionTypeDisplay.TEXT,
};
